import ProducerForm from './ProducerForm/ProducerForm';
import StoreForm from "@apps/CompanyRegistrations/RegisterFlow/Forms/StoreForm";
import RestaurantForm from "@apps/CompanyRegistrations/RegisterFlow/Forms/RestaurantForm";
import AssociationForm from "@apps/CompanyRegistrations/RegisterFlow/Forms/AssociationForm";
import CampsiteForm from "@apps/CompanyRegistrations/RegisterFlow/Forms/CampsiteForm";
import OtherForm from "@apps/CompanyRegistrations/RegisterFlow/Forms/OtherForm";

const forms = {
    producer: { fullscreen: true, component: ProducerForm },
    store: { fullscreen: true, component: StoreForm },
    restaurant: { fullscreen: true, component: RestaurantForm },
    association: { fullscreen: true, component: AssociationForm },
    campsite: { fullscreen: true, component: CampsiteForm },
    'ski-resort': { fullscreen: true, component: CampsiteForm },
    workplace: { fullscreen: true, component: CampsiteForm },
    festival: { fullscreen: false, component: OtherForm },
    other: { fullscreen: false, component: OtherForm },
}

export default forms